/**
 * 管理员路由守卫
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { token, user } = useAuthStore();
  const localStorageToken = localStorage.getItem('token');
  const hasValidToken = token || localStorageToken;

  if (!hasValidToken) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/projects" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
